export default "__VITE_ASSET__CxBJhhUk__"